var root = require('./_root');

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/lodash/_coreJsData.js
// module id = zw2X
// module chunks = 1